import { useEffect } from 'react';
import { initUTMTracking } from '@/utils/utm-tracking';

/**
 * Component to initialize UTM tracking on page load
 * Should be included early in the app lifecycle
 */
export function UTMInitializer() {
  useEffect(() => {
    initUTMTracking();
  }, []);

  // This component doesn't render anything
  return null;
}
